// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"1cc7789f","830":"cd19626d"}[chunkId] + ".chunk.js";
};